module.exports = __webpack_public_path__ + "static/img/ship-wasp_256.920adfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-wasp_256.png
// module id = 84KG
// module chunks = 0